"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorageUtil = void 0;
/**
 * Stores a value in localStorage with an expiry time (time-to-live).
 *
 * @param key - The key under which the value is stored.
 * @param value - The value to store. Can be any serializable object.
 * @param ttl - Time to live in milliseconds. After this period, the item will expire.
 */
function setWithExpiry(key, value, ttl) {
    const now = new Date();
    const item = {
        value: value,
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
}
/**
 * Retrieves a value from localStorage that was stored with an expiry time.
 * If the item has expired or does not exist, it is removed from storage and `undefined` is returned.
 *
 * @param key - The key of the item to retrieve.
 * @returns The stored value if it exists and has not expired; otherwise, `undefined`.
 */
function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return;
    }
    try {
        const item = JSON.parse(itemStr);
        if (!item.expiry || Date.now() > item.expiry) {
            localStorage.removeItem(key);
            return;
        }
        return item.value;
    }
    catch (_a) {
        localStorage.removeItem(key);
        return;
    }
}
exports.localStorageUtil = {
    setWithExpiry,
    getWithExpiry,
};
//# sourceMappingURL=localStorage.util.js.map